import { router } from "@inertiajs/react";
import { useEffect } from "react";

import Button from "hardcover-ui/components/Button";
import Container from "hardcover-ui/components/Container";
import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import Bugsnag from "lib/bugsnag";
import { enlargeUrl } from "lib/imageTools";

import NotFoundView from "./NotFoundView";

export default function ServerErrorView({
  clearError,
  error,
}: Readonly<{
  error: Error;
  clearError: () => void;
}>) {
  useEffect(() => {
    if (error?.message !== "NEXT_NOT_FOUND") {
      Bugsnag.notify(error);
    }
  }, []);

  const retry = () => {
    clearError();
    router.reload();
  };

  const goBack = () => {
    window.history.back();
    setTimeout(() => {
      clearError();
    }, 500);
  };

  if (error?.message === "NEXT_NOT_FOUND") {
    return <NotFoundView />;
  }

  return (
    <Container variant="layout" size="sm" className="text-center">
      <img
        src={enlargeUrl({
          path: "/static/errors/400-error.png",
          width: 480,
          height: 404,
        })}
        alt="Jules looking confused at the server"
        width={480}
        height={404}
        className="mx-auto"
      />

      <Heading level={1}>Oops! Our servers are acting up!</Heading>

      <div>
        <Text
          variant="secondary"
          as="p"
          className="max-w-lg text-center mx-auto"
        >
          We're very embarrassed by this, but something went wrong. Adam &amp;
          Ste have been notified and they're on the case!
        </Text>
        <p className="mt-4">
          <Button variant="primary" size="lg" onClick={retry}>
            Try Again?
          </Button>
        </p>

        <p className="mt-4">
          <Button variant="secondary" size="md" onClick={goBack}>
            Go back
          </Button>
        </p>
      </div>
    </Container>
  );
}
